import Image from "next/image";
import { eyeIcon } from "../../../public";
import { Button } from "../ui/button";
import { motion } from "framer-motion";
import { useRouter } from "next/navigation";
import { useState } from "react";
import DetailsSlidePopover from "./DetailsSlidePopover";
import { NoImage } from "../../../public";
import { useQuote } from "@/contexts/QuoteContext";
import Link from "next/link";
import ImageWithLoader from "./ImageWithLoader";
// import { useToast } from "@/contexts/ToastContext";

interface Product {
  id?: string;
  _id?: string;
  name?: string;
  slug?: string;
  image?: string;
  alt?: string;
  icon?: string;
  images?: string;
  src?: string;
  on_sale?: boolean;
  post_title?: string;
}

interface ProductListCardProps {
  // id: string;
  product: Product;
  priority?: boolean;
}

export default function ProductListCard({ product, priority = false }: ProductListCardProps) {
  const router = useRouter();
  const [isOpen, setIsOpen] = useState(false);
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const [isAddedToQuote, setIsAddedToQuote] = useState(false);
  const { addToQuote, quoteItems } = useQuote();
  // const { addToast } = useToast();

  // Check if product is already in quote
  const isProductInQuote = quoteItems.some(item => item.id === product.id);

  // const productImage =
  //   Array.isArray(product.images) &&
  //     product.images.length > 0 &&
  //     product.images[0]
  //     ? product.images[0].src
  //     : NoImage;

  return (
    <div className="p-mob-20 sm:p-tab-10 lg:p-web-20 flex flex-col border border-[#ececec] rounded-mob-6 sm:rounded-tab-6 lg:rounded-web-6 h-full hover:shadow-md transition-all duration-300">
      <div
        className="mb-mob-12 sm:mb-tab-12 lg:mb-web-12 relative cursor-pointer"
        onClick={(e) => {
          e.stopPropagation();
          // setIsOpen(true);
        }}
      >
        <div
          className="relative w-full h-[56.51vw] sm:h-[31.64vw] lg:h-[13.02vw]"
          // onClick={() => {
          //   router.push(`/details/${product?.slug}`);
          // }}
        >
        <Link 
          href={`/details/${product?.slug}`}
          // className="relative w-full h-[56.51vw] sm:h-[31.64vw] lg:h-[13.02vw]"
          >
            <ImageWithLoader
              src={product.images ?? NoImage}
              alt="Product Image"
              fill
              priority={priority}
              className="!static rounded-mob-10 sm:rounded-tab-10 lg:rounded-web-10 object-center object-contain"
              containerClassName="w-full h-full"
            />
          </Link>
        </div>
      </div>
      <div className="flex items-start justify-between mb-mob-23 sm:mb-tab-23 lg:mb-web-24">
        <span
          className="cursor-pointer hover:text-PrimaryDarkBlue max-w-[80%] text-mob-18 sm:text-tab-17 lg:text-web-20 leading-[126%] font-medium text-[#323232] line-clamp-3"
          // onClick={() => {
          //   router.push(`/details/${product?.slug}`);
          // }}
        >
          <Link href={`/details/${product?.slug}`}>
            {product.post_title}
          </Link>
        </span>
        <motion.div
          className="w-mob-33 sm:w-tab-33 lg:w-web-34 cursor-pointer"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 1 }}
          transition={{ duration: 0.1, ease: "easeOut" }}
          onClick={(e) => {
            e.stopPropagation();
            // setIsOpen(true);
          }}
        >
          <Image
            src={eyeIcon}
            alt="eye-icon"
            fill
            className="!static !h-auto"
            onClick={() => {
              setIsPopoverOpen(true);
            }}
          />
        </motion.div>
      </div>
      <Button
        variant="primaryOutLineBtn"
        className={
          isProductInQuote && !isAddedToQuote
            ? "bg-PrimaryLightBlue text-white border-blue-600 hover:bg-PrimaryLightBlue hover:border-blue-700"
            : ""
        }
        onClick={() => {
          // alert(`Product ID: ${product._id}, Product Name: ${product.post_title}`);
          // if (product.on_sale && product.id && product.name) {
          if (product.id && product.post_title) {
            // Add to quote
            addToQuote({
              id: product.id,
              name: product.post_title,
              slug: product.slug,
              images: product.images,
              quantity: 1,
              addedAt: new Date()
            });

            // Show temporary "Added" state
            setIsAddedToQuote(true);
            setTimeout(() => {
              setIsAddedToQuote(false);
            }, 1000);

            // Show success toast
            // addToast(`"${product.name}" added to quote successfully!`, 'success');
          } else {
            // Navigate to details page for regular quote request
            router.push(`/details/${product?.slug || product?.name}`);
          }
        }}
      >
        {(isAddedToQuote || isProductInQuote) ? (
          <div className="flex items-center justify-center gap-1">
            <span>Added</span>
          </div>
        ) : (
          "Add to Quote"
        )}
      </Button>

      {
        isPopoverOpen && product.id !== undefined && (
          <DetailsSlidePopover productId={product.id} close={() => setIsPopoverOpen(false)} />
        )
      }

      {/* Lightbox */}
      {isOpen && (
        <>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3 }}
            className="fixed inset-0 bg-black bg-opacity-80 flex justify-center items-center z-[151]"
            onClick={() => setIsOpen(false)}
          ></motion.div>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3 }}
            className="fixed rounded-mob-10 sm:rounded-tab-10 lg:rounded-web-10 bg-White z-[152] left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[90%] sm:w-[70%] lg:w-[50vw] lg:max-w-[700] h-[60vh]  lg:max-h-[600px]"
          >
            <Image
              src={product.images ?? NoImage}
              alt="Product Image"
              fill
              className="rounded-lg object-contain object-center"
            />
            <button
              className="absolute border transition-all duration-200 hover:scale-110 top-4 right-4 bg-white rounded-full p-mob-10 sm:p-tab-10 lg:p-web-10 h-mob-50 sm:h-tab-50 lg:h-web-50 w-mob-50 sm:w-tab-50 lg:w-web-50 shadow-lg"
              onClick={() => {
                setIsOpen(false);
              }}
            >
              <Image
                src="/images/closeBtn.svg"
                alt="Product Image"
                fill
                className="rounded-lg !static"
              />
            </button>
          </motion.div>
        </>
      )}
    </div>
  );
}
